/*
 * Copyright 2017 data.world, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * This product includes software developed at
 * data.world, Inc. (http://data.world/).
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './LoadingAnimation.css';

class LoadingAnimation extends Component {
  static propTypes = {
    label: PropTypes.string
  }

  render () {
    return (
      <div className='loaderoverlay'>
        <div className='loader-center'>
          <div className='loader'>Loading...</div>
          {this.props.label && <span className='loader-label'>{this.props.label}</span>}
        </div>
      </div>
    );
  }
}

export default LoadingAnimation;


// WEBPACK FOOTER //
// ./src/components/LoadingAnimation.js